import classNames from 'classnames';
import * as React from 'react';

import css from './BooksOutlineLabel.module.scss';

interface Props {
  className?: string;
  label: string;
}

const BooksOutlineLabel = ({ className, label }: Props) => {
  const classes = classNames(css.BooksOutlineLabel, className);

  return <span className={classes}>{label}</span>;
};

export default BooksOutlineLabel;
